module.exports = __webpack_public_path__ + "img/logo-toolbar-comp.48fbf21f.png";